import { render, staticRenderFns } from "./SelectRuleTemplateDialog.vue?vue&type=template&id=31673179&scoped=true&"
import script from "./SelectRuleTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./SelectRuleTemplateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SelectRuleTemplateDialog.vue?vue&type=style&index=0&id=31673179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31673179",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
